export const buttons = {
  primary: {
    color: "white",
    bg: "secondary",
    py: 3,
    px: 5,
    borderRadius: 1,
    fontSize: 2,
    cursor: "pointer",
    "&:hover": {
      bg: "text",
    },
  },
  icon: {
    color: "inherit",
    bg: "transparent",
    cursor: "pointer",
    p: 2,
    borderRadius: 2,
  },
  iconText: {
    borderRadius: 1,
    fontSize: 2,
    bg: "accent",
    display: "flex",
    alignItems: "center",
    height: "fit-content",
    cursor: "pointer",
    px: 7,
    py: 3,
    "*:first-of-type": {
      mr: 4,
    },
    boxShadow: 1,
  },
};
